/**
 * Supported data actions
 */
export const GET_LIST = "getList";
export const GET_EXPORT = "getExport";
export const GET_MANY = "getMany";
export const GET_ONE = "getOne";
export const CREATE = "create";
export const UPDATE = "update";
export const UPDATE_MANY = "updateMany";
export const DELETE = "delete";
export const DELETE_MANY = "deleteMany";

/**
 * Specific optional tree actions
 */
export const GET_TREE = "getTree";
export const GET_NODES = "getNodes";
export const MOVE_NODE = "moveNode";
